import { useState } from "react";
//--------------------------------------------------------------
import Modal from "src/components/common/modal";
import rightArrow from "src/img/rightArrow.png";
import { useMyStore } from "src/components/main/mainStore";
import {
    MyDate, defaultEmptyDateTime, MyFormData, myAxios, testerEmails
} from "src/components/common/functions";
import OptionalForms from "./forms";
import JobTag from "./requiredForms/jobTag";
import JobSafetyAnalysis from "./requiredForms/jobSafetyAnalysis";
import VehicleForm from "./requiredForms/vehicleForm";
import TrailerForm from "./requiredForms/trailerForm";
import PotholingForm from "./optionalForms/potholingForm";

const title = "WorkLogs";
//--------------------------------------------------------------
export function WorkLogContent({
    workLogs, 
    setWorkLogs, 
    weeknum, 
    id, 
    formName, 
    subFormName, 
    history, 
    adminLink,
    setWorkInstructions, 

    // workLog
    preTruck, 
    labor, 
    postTruckNumber, 
    postTruck, 
    projectHashKey, 
    perDiem, 
    projectName, 
    endTime, 
    workInstructionHashKey, 
    projectManagerEmail, 
    category, 
    userName, 
    preTruckNumber, 
    laborCategory, 
    workLogHashKey, 
    requiredForms, 
    startTime, 
    workLogStatus, 
    laborFolderId, 
    preDriverSubmitTime, 
    preDriver, 
    preTrailer, 
    jobSafetyAnalysisTemplate, 
    /* teamLead, */
    jobSafetyAnalysisSignId, 
    jsaSubmitTime, 
    jsaSaveTime, 
    delayJSA, 
    decisionTime, 
    jobTagSubmitTime, 
    jobTagSaveTime, 
    postDriverSubmitTime, 
    postDriver, 
    postTrailer, 
    potholingForm, 
    forms, 
    submitterEmail, 
    submitReason, 
    projectManager, 
    contactName, 
    jobSafetyAnalysisContent, 
    folderId, 
    attachmentFolderId, 
    jobSafetyAnalysisTemplateDoc, 
    jobSafetyAnalysisSignsId, 
    location, 
    jobTag, 
    defaultSignId, 
    contactEmail, 
    isFinished, 
    clientPONumber, 
    projectNumber, 
    clientProjectNumber, 
    workPerformed, 
    organizationName, 
    additionalInfo, 
    travelStartTime, 
    travelEndTime, 
    hadLunch, 
    startLocation,
    yardReason,
    workStartTime, 
    workEndTime, 
    supervisor, 
    supervisorEmail, 
    supervisorPhone, 
    workInstructionDescription, 
    accurateTime, 
    clientSignatureRequired, 
    sendToClient, 
    clientSupervisorName, 
    coords, 
    fieldSupervisorEmail, 
    fieldSupervisorName, 
    multiJSA,
    nearestMedicalFacility, 
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    //------------------------------------------------------------------
    const [showForms, setShowForms] = useState(false);
    //------------------------------------------------------------------
    const checkRequiredFormsStatus = key => {
        const requiredFormsObj = JSON.parse(requiredForms);
        if(key in requiredFormsObj){
            return requiredFormsObj[key].formSubmitTime!== defaultEmptyDateTime?"submitted":(
                requiredFormsObj[key].formSaveTime!== defaultEmptyDateTime?"saved":null)
        }else{
            return null;
        }     
    }
return (
<div className = "border rounded mb-2" style = {{position: "relative"}}>
    <div
        style = {{
            fontWeight: 650, 
            fontFamily: "sans-serif", 
            position: "absolute", 
            top: -11, 
            left: "1%", 
            padding: "0px 10px", 
            backgroundColor: "white"
        }}
    >
        Forms
    </div>
    <div
        style = {{
            fontWeight: 650, 
            fontFamily:"sans-serif", 
            position:"absolute", 
            top: -11, 
            right: "4%", 
            padding: "0px 10px", 
            backgroundColor: "white", 
            color: "blue", 
            cursor: "pointer"
        }}
        onClick = {() => {
            setShowForms(true);
        }}
    >
        Add
    </div>
    {(workLogStatus !== "Created" && workLogStatus !== "Rejected" && !adminLink)?
    <div className = "p-3 text-center h5">
        This job tag is already submitted. 
        <span
            className = "btn btn-info ml-4"
            onClick = {async () => {
                if(workLogStatus !== "Submitted"){
                    window.alert("This job is already approved.");
                    return;
                };
                const today = new MyDate();
                const todayDate = today.s();
                const todayTime = today.ss();
                const startDate = startTime.substring(0, 10);
                //----------------------------------------------------
                const pre = weeknum(startDate).substring(0, 6);
                let v = window.Number.parseInt(weeknum(startDate).substring(6, 8)) + 1;
                if(v < 10){v++;}
                const final = pre + v;
                //----------------------------------------------------
                if(
                    ((weeknum(todayDate)) > final) ||
                    (
                        (weeknum(todayDate)) > (weeknum(startDate)) && 
                        (
                            (((new Date(todayDate.replace(/-/g, "/"))).getDay() === 2) && todayTime.slice(-2) === "PM" )
                            || ((new Date(todayDate.replace(/-/g, "/"))).getDay() > 2)
                        )
                    
                    )
                ){
                    window.alert("This job is too old to edit. please contact accounting.");
                    return;
                }
                
                const formData = new MyFormData();
                formData.append("workLogHashKey", workLogHashKey);
                //---------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios("workLogs/withdraw.php", formData);
                setShowLoader(false);
                if(!res) return;
                //---------------------------------------------------------
                setWorkLogs(workLogs => workLogs.map(workLog => ({
                    ...workLog, 
                    workLogStatus: ( id === workLog.workLogHashKey ?"Created":workLog.workLogStatus)})));
                history.push(`/${title}`);
            }}
        >
            Withdraw
        </span>
    </div>
    :null}
    <>
        {(workLogStatus !== "Created" && workLogStatus !== "Rejected" && !adminLink)?null:
        <>
            {laborCategory === "Locating"?
            <>
                {/************** locating pre checklist title **************/}
                <button
                    type = "button"
                    className = "btn btn-info my-3 mx-3"
                    onClick = {async () => {
                        if(adminLink){
                            history.push(`${adminLink}/${id}/PreChecklist`);
                        }else{
                            history.push(`/${title}/${id}/PreChecklist`);
                        }
                    }}
                >
                    Pre CheckList
                </button>
                <StatusIcon
                    status = {checkRequiredFormsStatus("locatingPreChecklist")}
                />
                {/************** locating pre checklist **************/}
                {formName === "PreChecklist" && 
                laborFolderId?
                <OptionalForms
                    formRequired = {true}
                    admin = {adminLink}
                    closeIt = {() => {
                        if(adminLink){
                            history.push(`${adminLink}/${id}`);
                        }else{
                            history.push(`/${title}/${id}`);
                        }
                    }}
                    setWorkLogs = {setWorkLogs}
                    formName = {"locatingPreChecklist"}
                    title = {"LOCATING PRE-CHECKLIST"}

                    // workLog
                    requiredForms = {requiredForms}
                    workLogHashKey = {workLogHashKey}
                    laborFolderId = {laborFolderId} 
                    projectHashKey = {projectHashKey} 
                    workInstructionHashKey = {workInstructionHashKey}
                    userName = {userName}
                />
                :null}
                {/*******************************************/}
            </>:null}
            {laborCategory === "Potholing"?
            <>
                {/************** potholing pre checklist title **************/}
                <button
                    type = "button"
                    className = "btn btn-info my-3 mx-3"
                    onClick = {async () => {
                        if(adminLink){
                            history.push(`${adminLink}/${id}/PreChecklist`);
                        }else{
                            history.push(`/${title}/${id}/PreChecklist`);
                        }
                    }}
                >
                    Pre CheckList
                </button>
                <StatusIcon status = {
                    checkRequiredFormsStatus("potholingPreChecklist")
                }/>
                {/************** potholing pre checklist **************/}
                {formName === "PreChecklist" && 
                laborCategory === "Potholing" &&
                laborFolderId?
                <OptionalForms
                    formRequired = {true}
                    admin = {adminLink}
                    closeIt = {() => {
                        if(adminLink){
                            history.push(`${adminLink}/${id}`);
                        }else{
                            history.push(`/${title}/${id}`);
                        }
                    }}
                    setWorkLogs = {setWorkLogs}
                    formName = {"potholingPreChecklist"}
                    title = {"POTHOLING PRE-CHECKLIST"}
                    // workLog
                    requiredForms = {requiredForms}
                    workLogHashKey = {workLogHashKey}
                    laborFolderId = {laborFolderId} 
                    projectHashKey = {projectHashKey} 
                    workInstructionHashKey = {workInstructionHashKey}
                    userName = {userName}
                />
                :null}
                {/*******************************************/}
            </>:null}
            {/************** pre vehicle inspection title **************/}
            {laborCategory !== "Images"?<>
            <button
                type = "button"
                className = "btn btn-info my-3 mx-3"
                onClick = {async () => {
                    if(adminLink){
                        history.push(`${adminLink}/${id}/PreVehicleForm`);
                    }else{
                        history.push(`/${title}/${id}/PreVehicleForm`);
                    }
                }}
            >
                PreWork Vehicle Inspection
            </button>
            <StatusIcon status = {
                preDriverSubmitTime !== defaultEmptyDateTime 
                || preDriver === "No"?"submitted":""
            }/>
            </>:<></>}
            {/************** pre vehicle inspection **************/}
            {laborCategory !== "Images" && formName === "PreVehicleForm" && laborFolderId?
            <VehicleForm
                preOrPost = {"pre"}
                closeIt = {() => {
                    if(adminLink){
                        history.push(`${adminLink}/${id}`);
                    }else{
                        history.push(`/${title}/${id}`);
                    }
                }}
                setWorkLogs = {setWorkLogs}
                workLogHashKey = {workLogHashKey}
                category = {category}
                userName = {userName}
                driverStr = {preDriver} 
                truckNumberStr = {preTruckNumber}
                truckStr = {preTruck}
            />
            :<></>}
            {preDriver === "Yes"?<>
            {/************** pre trailer inspection title **************/}
            {laborCategory !== "Images"?<>
            <button
                type = "button"
                className = "btn btn-info my-3 mx-3"
                onClick = {async () => {
                    if(adminLink){
                        history.push(`${adminLink}/${id}/PreTrailerForm`);
                    }else{
                        history.push(`/${title}/${id}/PreTrailerForm`);
                    }
                }}
            >
                PreWork Trailer Inspection
            </button>
            <StatusIcon status = {((preTrailer && JSON.parse(preTrailer).submitTime) || preDriver === "No")?"submitted":""}/>
            </>:<></>}
            {/************** pre trailer inspection **************/}
            {laborCategory !== "Images" && formName === "PreTrailerForm" && laborFolderId?
            <TrailerForm
                preOrPost = {"pre"}
                closeIt = {() => {
                    if(adminLink){
                        history.push(`${adminLink}/${id}`);
                    }else{
                        history.push(`/${title}/${id}`);
                    }
                }}
                setWorkLogs = {setWorkLogs}
                workLogHashKey = {workLogHashKey}
                trailerStr = {preTrailer}
                userName = {userName}
            />
            :<></>}
            </>:<></>}
        </>}
        {/*******************************************************/}
        {!jobSafetyAnalysisTemplate && 
        false/* teamLead !== labor */ &&
        laborCategory.indexOf("Shop") === -1 &&
        laborCategory.indexOf("Training") === -1?
        <div className = "p-3 text-center h5">
            JSA Initiator has not initiated JSA yet.
        </div>:
        <>
            {laborCategory.indexOf("Shop") === -1?
            <>
                {(workLogStatus !== "Created" && workLogStatus !== "Rejected" && !adminLink)?<></>:
                <>
                {/************** JSA title **************/}
                {laborCategory !== "Images"?<>
                <button
                    type = "button"
                    className = "btn btn-info my-3 mx-3"
                    onClick = {async () => {
                        if(adminLink){
                            history.push(`${adminLink}/${id}/JSA`);
                        }else{
                            history.push(`/${title}/${id}/JSA`);
                        }
                    }}
                >
                    Job Safety Analysis
                </button>
                <StatusIcon
                    status = {
                        jsaSubmitTime !== defaultEmptyDateTime?
                        "submitted":
                        (jsaSaveTime !== defaultEmptyDateTime?
                        "saved":null
                        )
                    }
                />
                </>:<></>}
                {/************** JSA **************/}
                {laborCategory !== "Images" && formName === "JSA" && laborFolderId?
                <JobSafetyAnalysis
                    adminLink = {adminLink}
                    setWorkInstructions = {setWorkInstructions}

                    setWorkLogs = {setWorkLogs}
                    closeIt = {() => {
                        if(adminLink){
                            history.push(`${adminLink}/${id}`);
                        }else{
                            history.push(`/${title}/${id}`);
                        }
                    }}
                    // workLog
                    jobSafetyAnalysisContent = {jobSafetyAnalysisContent}
                    /* teamLead = {teamLead} */
                    labor = {labor}
                    laborCategory = {laborCategory}
                    jobSafetyAnalysisTemplate = {jobSafetyAnalysisTemplate}
                    folderId = {folderId}
                    attachmentFolderId = {attachmentFolderId}
                    projectName = {projectName}
                    startTime = {startTime}
                    endTime = {endTime}
                    jobSafetyAnalysisTemplateDoc = {jobSafetyAnalysisTemplateDoc}
                    workLogHashKey = {workLogHashKey}
                    laborFolderId = {laborFolderId}
                    workInstructionHashKey = {workInstructionHashKey}
                    jobSafetyAnalysisSignId = {jobSafetyAnalysisSignId}
                    jobSafetyAnalysisSignsId = {jobSafetyAnalysisSignsId}
                    userName = {userName}
                    location = {location}
                    nearestMedicalFacility = {nearestMedicalFacility}
                />:null}
                {/**********************************/}
                {/************** multi site JSA title **************/}
                {JSON.parse(multiJSA || "[]").filter(form => form.workLogHashKey === workLogHashKey || form.helpers?.[workLogHashKey] !== undefined).map((form, i) =>  
                <span key = {i}>
                    <button
                        type = "button"
                        style = {{position: "relative"}}
                        className = {`btn btn-info my-3 mx-3`}
                        onClick = {async e => {
                            if(e.currentTarget === e.target){
                                if(adminLink){
                                    history.push(`${adminLink}/${id}/${form.hashKey}`);
                                }else{
                                    history.push(`/${title}/${id}/${form.hashKey}`);
                                }            
                            }
                        }}
                    >
                        <span
                            className = "badge badge-danger"
                            style = {{
                                position:"absolute", 
                                top: -5, left: -5, 
                                fontSize: 15
                            }}
                            onClick = {async () => {
                                if(!window.confirm("Are you sure to delete this form?")) return;
                                const formData = new MyFormData();
                                formData.append("form", form.form);
                                formData.append("workLogHashKey", workLogHashKey);
                                formData.append("formHashKey", form.hashKey);
                                //---------------------------------------------------------
                                setShowLoader(true);
                                const res = await myAxios("workLogs/deleteForm.php", formData);
                                setShowLoader(false);
                                if(!res) return;
                                //---------------------------------------------------------
                                if(adminLink){
                                    setWorkInstructions(workInstructions => workInstructions.map(workInstruction => ({
                                        ...workInstruction, 
                                        multiJSA: 
                                        workInstruction.workInstructionHashKey === workInstructionHashKey && res.data[0]?
                                        res.data[0]:workInstruction.forms,
                                        workInstructionFiles: 
                                        workInstruction.workLogHashKey === workInstructionHashKey && res.data[1]?
                                        res.data[1]:workInstruction.workInstructionFiles
                                    })));
                                }else{
                                    setWorkLogs(workLogs => workLogs.map(workLog => ({
                                        ...workLog, 
                                        multiJSA: 
                                        workLog.workLogHashKey === id && res.data[0]?
                                        res.data[0]:workLog.forms,
                                        workInstructionFiles: 
                                        workLog.workLogHashKey === id && res.data[1]?
                                        res.data[1]:workLog.workInstructionFiles
                                    })));
                                }
                            }}
                        >x</span>
                        {form.form} {form.docNum !== "undefined"?form.docNum:null} 
                    </button>
                    <StatusIcon status = {
                        form.formSubmitTime?"submitted":(
                        form.formSaveTime?"saved":null)
                    }/>
                </span>
                )}
                {/************** optional forms **************/}
                {laborFolderId && 
                (JSON.parse(multiJSA || "[]").some(eachForm => eachForm.hashKey === formName) || JSON.parse(multiJSA || "[]").some(eachForm => eachForm.helpers?.[workInstructionHashKey] !== undefined))?
                <OptionalForms
                    /* Potholing Form */
                    // closeIt = {() => setShowPotholingForm(false)}
                    // picData2 = {potholingFormPicData2}
                    // setPicData2 = {potholingFormSetPicData2}
                    // resizeCanvas = {resizeCanvas}
                    // cropCanvas = {cropCanvas}
                    /*****************/
                    closeIt = {() => {
                        if(adminLink){
                            history.push(`${adminLink}/${id}`);
                        }else{
                            history.push(`/${title}/${id}`);
                        }
                    }}
                    form = {JSON.parse(multiJSA || "[]").find(ww => ww.hashKey === formName)}
                    title = {JSON.parse(multiJSA || "[]").find(ww => ww.hashKey === formName).form.toUpperCase()}
                    setWorkLogs = {setWorkLogs}
                    // workLog
                    requiredForms = {requiredForms}
                    workLogHashKey = {workLogHashKey}
                    laborFolderId = {laborFolderId} 
                    projectHashKey = {projectHashKey}
                    workInstructionHashKey = {workInstructionHashKey}
                    userName = {userName}
                    location = {location}
                    nearestMedicalFacility = {nearestMedicalFacility}
                    // workLog attributes for secondary JSA
                    
                    labor = {labor}
                    laborCategory = {laborCategory}
                    
                    folderId = {folderId} 
                    attachmentFolderId = {attachmentFolderId} 
                    projectName = {projectName} 
                    startTime = {startTime}
                    endTime = {endTime}

                    adminLink = {adminLink}
                    setWorkInstructions = {setWorkInstructions}
                />:null}
                </>}
            </>:null}
            {jsaSubmitTime !== defaultEmptyDateTime || 
            laborCategory.indexOf("Shop") > -1 ||
            delayJSA === "1" || adminLink?
            <>
                {(workLogStatus !== "Created" && workLogStatus !== "Rejected" && !adminLink)?null:
                <>
                    {laborCategory !== "Images" && laborCategory.indexOf("Shop") === -1 &&
                    laborCategory.indexOf("Training") === -1?
                    <img src = {rightArrow} alt = "" style = {{width: 30}}/>
                    :<></>}
                    {/************** job tag title **************/}
                    {laborCategory !== "Images"?<>
                    <button
                        type = "button"
                        className = "btn btn-info my-3 mx-3"
                        onClick = {() => {
                            if(adminLink){
                                history.push(`${adminLink}/${id}/JobTag`);
                            }else{
                                history.push(`/${title}/${id}/JobTag`);
                            }
                        }}
                    >
                        Job Tag
                    </button>
                    <StatusIcon status = {
                        decisionTime !== defaultEmptyDateTime?"decided":(
                        jobTagSubmitTime!== defaultEmptyDateTime?"submitted":(
                        jobTagSaveTime!== defaultEmptyDateTime?"saved":null)
                        )
                    }/>
                    </>:<></>}
                    {/************** job tag **************/}
                    {laborCategory !== "Images" && formName === "JobTag" && laborFolderId?
                    <JobTag
                        closeIt = {() => {
                            if(adminLink){
                                history.push(`${adminLink}/${id}`);
                            }else{
                                history.push(`/${title}/${id}`);
                            }
                        }}
                        history = {history}
                        /*------------------------------------*/
                        workLogs = {workLogs}
                        setWorkLogs = {setWorkLogs}
                        admin = {adminLink}

                        labor = {labor}
                        laborFolderId = {laborFolderId}
                        workInstructionHashKey = {workInstructionHashKey}
                        projectHashKey = {projectHashKey} 
                        projectName = {projectName}
                        jobTag = {jobTag}
                        defaultSignId = {defaultSignId}
                        contactEmail = {contactEmail} 
                        contactName = {contactName}
                        userName = {userName} 
                        preDriver = {preDriver}
                        postDriver = {postDriver} 
                        isFinished = {isFinished}
                        clientPONumber = {clientPONumber}
                        projectNumber = {projectNumber} 
                        projectManager = {projectManager} 
                        clientProjectNumber = {clientProjectNumber}
                        workPerformed = {workPerformed} 
                        organizationName = {organizationName}
                        additionalInfo = {additionalInfo}
                        travelStartTime = {travelStartTime}
                        travelEndTime = {travelEndTime}
                        hadLunch = {hadLunch}
                        startLocation = {startLocation}
                        yardReason = {yardReason}
                        workStartTime = {workStartTime} 
                        workEndTime = {workEndTime} 
                        location = {location}
                        supervisor = {supervisor}
                        supervisorEmail = {supervisorEmail}
                        supervisorPhone = {supervisorPhone}
                        workInstructionDescription = {workInstructionDescription}
                        startTime = {startTime}
                        endTime = {endTime} 
                        category = {category}
                        accurateTime = {accurateTime}
                        clientSignatureRequired = {clientSignatureRequired}
                        sendToClient = {sendToClient}
                        workLogHashKey = {workLogHashKey}
                        clientSupervisorName = {clientSupervisorName}
                        laborCategory = {laborCategory}
                        coords = {coords}
                        fieldSupervisorEmail = {fieldSupervisorEmail}
                        fieldSupervisorName = {fieldSupervisorName}
                    />
                    :<></>}
                    {/************** post vehicle inspection title **************/}
                    <>
                        {laborCategory !== "Images"?<>
                        <button
                            type = "button"
                            className = "btn btn-info my-3 mx-3"
                            onClick = {async () => {
                                if(adminLink){
                                    history.push(`${adminLink}/${id}/PostVehicleForm`);
                                }else{
                                    history.push(`/${title}/${id}/PostVehicleForm`);
                                }
                            }}
                        >
                            PostWork Vehicle Inspection
                        </button>
                        <StatusIcon status = {postDriverSubmitTime !== defaultEmptyDateTime || postDriver === "No"?"submitted":""}/>
                        </>:<></>}
                    </>
                    {/************** post vehicle inspection **************/}
                    {laborCategory !== "Images" && formName === "PostVehicleForm" && laborFolderId?
                    <VehicleForm
                        preOrPost = {"post"}
                        closeIt = {() => {
                            if(adminLink){
                                history.push(`${adminLink}/${id}`);
                            }else{
                                history.push(`/${title}/${id}`)
                            }  
                        }}
                        setWorkLogs = {setWorkLogs}
                        workLogHashKey = {workLogHashKey}
                        category = {category}
                        userName = {userName}
                        driverStr = {postDriver} 
                        truckNumberStr = {postTruckNumber}
                        truckStr = {postTruck}
                    />
                    :null}
                    {postDriver === "Yes"?<>
                    {/************** post trailer inspection title **************/}
                    {laborCategory !== "Images"?<>
                    <button
                        type = "button"
                        className = "btn btn-info my-3 mx-3"
                        onClick = {async () => {
                            if(adminLink){
                                history.push(`${adminLink}/${id}/PostTrailerForm`);
                            }else{
                                history.push(`/${title}/${id}/PostTrailerForm`);
                            }
                        }}
                    >
                        PostWork Trailer Inspection
                    </button>
                    <StatusIcon status = {((postTrailer && JSON.parse(postTrailer).submitTime) || postDriver === "No")?"submitted":""}/>
                    </>:<></>}
                    {/************** post trailer inspection **************/}
                    {laborCategory !== "Images" && formName === "PostTrailerForm" && laborFolderId?
                    <TrailerForm
                        preOrPost = {"post"}
                        closeIt = {() => {
                            if(adminLink){
                                history.push(`${adminLink}/${id}`);
                            }else{
                                history.push(`/${title}/${id}`);
                            }
                        }}
                        setWorkLogs = {setWorkLogs}
                        workLogHashKey = {workLogHashKey}
                        trailerStr = {postTrailer}
                        userName = {userName}
                    />
                    :null}
                    </>:null}
                    {laborCategory === "Locating"?
                    <>
                        {/************** locating post checklist title **************/}
                        <button
                            type = "button"
                            className = "btn btn-info my-3 mx-3"
                            onClick = {async () => {
                                if(adminLink){
                                    history.push(`${adminLink}/${id}/PostChecklist`);
                                }else{
                                    history.push(`/${title}/${id}/PostChecklist`);
                                }
                            }}
                        >
                            Post CheckList
                        </button>
                        <StatusIcon status = {
                            checkRequiredFormsStatus("locatingPostChecklist")
                        }/>
                        {/************** locating post checklist **************/}
                        {formName === "PostChecklist" && 
                        laborFolderId?
                        <OptionalForms
                            formRequired = {true}
                            admin = {adminLink}
                            closeIt = {() => {
                                if(adminLink){
                                    history.push(`${adminLink}/${id}`);
                                }else{
                                    history.push(`/${title}/${id}`);
                                }
                            }}
                            setWorkLogs = {setWorkLogs}
                            formName = {"locatingPostChecklist"}
                            title = {"LOCATING POST-CHECKLIST"}
                            // workLog
                            requiredForms = {requiredForms}
                            workLogHashKey = {workLogHashKey}
                            laborFolderId = {laborFolderId} 
                            projectHashKey = {projectHashKey} 
                            workInstructionHashKey = {workInstructionHashKey}
                            userName = {userName}
                        />:null}
                    </>:null}
                    {laborCategory === "Potholing"?<>
                        {/************** potholing post checklist title **************/}
                        <button
                            type = "button"
                            className = "btn btn-info my-3 mx-3"
                            onClick = {async () => {
                            if(adminLink){
                                history.push(`${adminLink}/${id}/PostChecklist`);
                            }else{
                                history.push(`/${title}/${id}/PostChecklist`);
                            }
                        }}>
                            Post CheckList
                        </button>
                        <StatusIcon status = {
                            checkRequiredFormsStatus("potholingPostChecklist")
                        }/>
                        {/************** potholing post checklist **************/}
                        {formName === "PostChecklist" && 
                        laborFolderId?
                        <OptionalForms
                            formRequired = {true}
                            admin = {adminLink}
                            closeIt = {() => {
                                if(adminLink){
                                    history.push(`${adminLink}/${id}`);
                                }else{
                                    history.push(`/${title}/${id}`);
                                }
                            }}
                            setWorkLogs = {setWorkLogs}
                            formName = {"potholingPostChecklist"}
                            title = {"POTHOLING POST-CHECKLIST"}
                            // workLog
                            requiredForms = {requiredForms}
                            workLogHashKey = {workLogHashKey}
                            laborFolderId = {laborFolderId} 
                            projectHashKey = {projectHashKey} 
                            workInstructionHashKey = {workInstructionHashKey}
                            userName = {userName}
                        />:null}
                    </>:null}
                </>}
                {/************** potholing forms title **************/}
                {JSON.parse(potholingForm).map((phForm, key) => 
                <span key = {key}>
                    <button
                        type = "button"
                        style = {{position: "relative"}}
                        className = {`btn btn-${phForm.cancel !== "Yes"?"info":"secondary"} my-3 mx-3`}
                        onClick = {async e => {
                            if(e.currentTarget === e.target){
                                if(adminLink){
                                    history.push(`${adminLink}/${id}/PotholingForm/${phForm.hashKey}`);
                                }else{
                                    history.push(`/${title}/${id}/PotholingForm/${phForm.hashKey}`);
                                }
                            }
                        }}
                    >
                        {true?
                        <span
                            className = "badge badge-danger"
                            style = {{
                                position:"absolute", 
                                top: -5, left: -5, 
                                fontSize: 15
                            }}
                            onClick = {async () => {
                                if(!window.confirm("Are you sure to delete this potholing form?")) return;
                                const formData = new MyFormData();
                                formData.append("form", "potholing");
                                formData.append("workLogHashKey", workLogHashKey);
                                formData.append("potholingFormHashKey", phForm.hashKey);
                                //---------------------------------------------------------
                                setShowLoader(true);
                                const res = await myAxios("workLogs/deleteForm.php", formData);
                                setShowLoader(false);
                                if(!res) return;
                                //---------------------------------------------------------
                                setWorkLogs(workLogs => workLogs.map(workLog => ({
                                    ...workLog, 
                                    potholingForm: 
                                    workLog.workLogHashKey === id && res.data[0]?
                                    res.data[0]
                                    :
                                    workLog.potholingForm,
                                    workLogFiles: 
                                    workLog.workLogHashKey === id && res.data[1]?
                                    JSON.parse(res.data[1])
                                    :
                                    workLog.workLogFiles
                                })));
                            }}
                        >
                            x
                        </span>:null}
                        Potholing Form {phForm.potholeNumber}
                    </button>
                    <StatusIcon status = {
                        phForm.potholingFormSubmitTime!== defaultEmptyDateTime?"submitted":(
                            phForm.potholingFormSaveTime!== defaultEmptyDateTime?"saved":null)
                    }/>
                </span>)}
                {/************** potholing forms **************/}
                {laborFolderId && 
                formName === "PotholingForm" &&
                JSON.parse(potholingForm).some(ww => ww.hashKey === subFormName)?
                <PotholingForm
                    closeIt = {() => {
                        if(adminLink){
                            history.push(`${adminLink}/${id}`);
                        }else{
                            history.push(`/${title}/${id}`);
                        }
                    }}
                    setWorkLogs = {setWorkLogs}  
                    adminLink = {adminLink}
                    potholingFormObj = {
                        JSON.parse(potholingForm)
                        .map((p, pi) => ({index: pi, ...p}))
                        .find(ww => ww.hashKey === subFormName)
                    }
                    // workLog
                    laborFolderId = {laborFolderId} 
                    workLogHashKey = {workLogHashKey} 
                    workInstructionHashKey = {workInstructionHashKey}
                    projectName = {projectName}
                    userName = {userName}
                    contactName = {contactName}
                />
                :null}
                {/************** optional forms title **************/}
                {JSON.parse(forms).map((form, i) =>  
                <span key = {i}>
                    <button
                        type = "button"
                        style = {{position: "relative"}}
                        className = {`btn btn-${form.cancel !== "Yes"?"info":"secondary"} my-3 mx-3`}
                        onClick = {async e => {
                            if(e.currentTarget === e.target){
                                if(adminLink){
                                    history.push(`${adminLink}/${id}/${form.hashKey}`);
                                }else{
                                    history.push(`/${title}/${id}/${form.hashKey}`);
                                }            
                            }
                        }}
                    >
                        <span
                            className = "badge badge-danger"
                            style = {{
                                position:"absolute", 
                                top: -5, left: -5, 
                                fontSize: 15
                            }}
                            onClick = {async () => {
                                if(!window.confirm("Are you sure to delete this form?")) return;
                                const formData = new MyFormData();
                                formData.append("form", form.form);
                                formData.append("workLogHashKey", workLogHashKey);
                                formData.append("formHashKey", form.hashKey);
                                //---------------------------------------------------------
                                setShowLoader(true);
                                const res = await myAxios("workLogs/deleteForm.php", formData);
                                setShowLoader(false);
                                if(!res) return;
                                //---------------------------------------------------------
                                setWorkLogs(workLogs => workLogs.map(workLog => ({
                                    ...workLog, 
                                    forms: 
                                    workLog.workLogHashKey === id && res.data[0]?
                                    res.data[0]:workLog.forms,
                                    workLogFiles: 
                                    workLog.workLogHashKey === id && res.data[1]?
                                    JSON.parse(res.data[1]):workLog.workLogFiles
                                })));
                            }}
                        >x</span>
                        {form.form} {form.docNum !== "undefined"?form.docNum:null} 
                    </button>
                    <StatusIcon status = {
                        form.formSubmitTime!== defaultEmptyDateTime?"submitted":(
                        form.formSaveTime!== defaultEmptyDateTime?"saved":null)
                    }/>
                </span>
                )}
            </>:null}
            {/************** optional forms **************/}
            {laborFolderId && 
            JSON.parse(forms).some(ww => ww.hashKey === formName)?
            <OptionalForms
                /* Potholing Form */
                // closeIt = {() => setShowPotholingForm(false)}
                // picData2 = {potholingFormPicData2}
                // setPicData2 = {potholingFormSetPicData2}
                // resizeCanvas = {resizeCanvas}
                // cropCanvas = {cropCanvas}
                /*****************/
                closeIt = {() => {
                    if(adminLink){
                        history.push(`${adminLink}/${id}`);
                    }else{
                        history.push(`/${title}/${id}`);
                    }
                }}
                form = {JSON.parse(forms).find(ww => ww.hashKey === formName)}
                title = {JSON.parse(forms).find(ww => ww.hashKey === formName).form.toUpperCase()}
                setWorkLogs = {setWorkLogs}
                // workLog
                requiredForms = {requiredForms}
                workLogHashKey = {workLogHashKey}
                laborFolderId = {laborFolderId} 
                projectHashKey = {projectHashKey}
                workInstructionHashKey = {workInstructionHashKey}
                userName = {userName}
                location = {location}
                // workLog attributes for secondary JSA
                
                labor = {labor}
                laborCategory = {laborCategory}
                
                folderId = {folderId} 
                attachmentFolderId = {attachmentFolderId} 
                projectName = {projectName} 
                startTime = {startTime}
                endTime = {endTime}
            />:null}
            {/************** add form **************/}
            {showForms?
            <AddForm
                setShowForms = {setShowForms}
                setWorkLogs = {setWorkLogs}

                // workLog
                laborCategory = {laborCategory}
                jsaSubmitTime = {jsaSubmitTime}
                workLogHashKey = {workLogHashKey}
               
                adminLink = {adminLink}
                workInstructionHashKey = {workInstructionHashKey}
                setWorkInstructions = {setWorkInstructions}
            />:null}
            {/********************************************************************/}
        </>}
    </>
    <div className = "d-flex justify-content-end mr-5">
        {workLogStatus !== "Created" && workLogStatus !== "Rejected"?
        <>
        {adminLink && submitterEmail?
        <div>
            <div><strong>Submitted by:</strong> {submitterEmail}</div>
            <div><strong>Reason:</strong> {submitReason}</div>
        </div>:null}
        </>:
        <button
            type = "button"
            className = "btn btn-success my-3 mx-3"
            id = {workLogHashKey}
            onClick = {async () => {
                if(JSON.parse(multiJSA || "[]").some(item => !item.formSubmitTime)){
                    window.alert("You haven't sumbmit Multi Site JSA.");
                    return;
                }
                if(laborCategory !== "Images"){
                    if(jsaSubmitTime === defaultEmptyDateTime && laborCategory.indexOf("Shop") === -1){
                        window.alert("You haven't submit Job Safety Analysis.");
                        return;
                    }
                    if(!preDriver && laborCategory.indexOf("Shop") === -1){
                        window.alert("You haven't submit Pre-Work Truck Inspection Form.");
                        return;
                    }
                    if(!((preTrailer && JSON.parse(preTrailer).submitTime) || preDriver === "No")){
                        window.alert("You haven't submit Pre-Work Trailer Inspection Form.");
                        return;
                    }
                    if(jobTagSubmitTime === defaultEmptyDateTime){
                        window.alert("You haven't submit Job Tag.");
                        return;
                    }
                    if(!postDriver && laborCategory.indexOf("Shop") === -1){
                        window.alert("You haven't submit Post-Work Truck Inspection Form.");
                        return;
                    }
                    if(!((postTrailer && JSON.parse(postTrailer).submitTime) || postDriver === "No")){
                        window.alert("You haven't submit Pre-Work Trailer Inspection Form.");
                        return;
                    }
                    // const potholingForms = JSON.parse(potholingForm);
                    // let phformValid = true;
                    // for(let phForm of potholingForms){
                    //     if(phForm.potholingFormSubmitTime === defaultEmptyDateTime){
                    //         phformValid = false;
                    //         break;
                    //     }
                    // }
                    // if(!phformValid){
                    //     window.alert("You haven't submitted Potholing Form.");
                    //     return;
                    // }
                }
                if(!window.confirm("are you sure to submit?")) return;
                const formData = new MyFormData();
                if(adminLink){
                    let reason = window.prompt("Reason to submit for the techniciaon:");
                    if(reason === null) return;
                    if(reason === ""){
                        window.alert("Reason is required.");
                        reason = window.prompt("Reason to submit for the techniciaon:");
                        if(reason === null) return;
                    }
                    formData.append("submitReason", reason);
                    formData.append("userEmail", labor);
                }
                formData.append("projectHashKey", projectHashKey);
                if(perDiem === "Yes"){
                    const curTime = new Date(startTime.substring(0, 10).replace(/-/g, "/"));
                    //---------------------------------------------------------
                    setShowLoader(true)
                    const res0 = await myAxios("common/readPerDiem.php", formData);
                    setShowLoader(false);
                    if(!res0) return;
                    //---------------------------------------------------------
                    if(res0.data.length === 0){
                        window.alert("You need to submit per diem for this project first."); 
                        return;
                    };
                    let bool = false;
                    for(let {startDate, endDate} of res0.data){
                        const start = new Date(startDate.replace(/-/g, "/"));
                        const end = new Date(endDate.replace(/-/g, "/"));
                        if(curTime >= start && curTime <= end){
                            bool = true;
                        }
                    }
                    if(!bool){
                        window.alert("You need to submit per diem for this day first."); 
                        return;
                    }
                }
                formData.append("workLogHashKey", workLogHashKey);
                formData.append("name", `${projectName}&nbsp;&nbsp;${startTime}~${endTime}`);
                formData.append("workInstructionHashKey", workInstructionHashKey);
                formData.append("projectManager", projectManager);
                formData.append("projectManagerEmail", projectManagerEmail);
                //---------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios("workLogs/submit.php", formData);
                if(!res) return;
                setShowLoader(false);
                //---------------------------------------------------------
                setWorkLogs(workLogs => workLogs.map(workLog => ({
                    ...workLog, 
                    workLogStatus: id === workLog.workLogHashKey?"Submitted":workLog.workLogStatus
                })));
                if(adminLink){
                    history.push(`${adminLink}/${id}`);
                }else{
                    history.push(`/${title}`);
                }
            }}
        >
            Submit
        </button>}
    </div>
</div>)
}

function StatusIcon({status}){
    switch(status){
        case "saved":
            return(
                <span
                    className = "badge badge-primary"
                    style = {{
                        position:"relative", 
                        marginLeft: -40, 
                        top: -15
                    }}
                >
                    saved
                </span>
            )
        case "submitted":
            return(
                <span
                    className = "badge badge-primary"
                    style = {{
                        position:"relative", 
                        marginLeft: -30, 
                        top: -15
                    }}
                >
                    ✓
                </span>
            )
        case "decided":
            return(
                <span
                    className = "badge badge-primary"
                    style = {{
                        position:"relative", 
                        marginLeft: -30, 
                        top: -15
                    }}
                >
                    decided
                </span>
            )
        default:
            return <></>;
    }
}

function AddForm({
    setShowForms, 
    setWorkLogs, 

    // workLog
    laborCategory, 
    jsaSubmitTime, 
    workLogHashKey,

    adminLink, 
    workInstructionHashKey, 
    setWorkInstructions
}){
    const user = useMyStore(state => state.user);
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [form, setForm] = useState("");
    return(
    <Modal
        width = {600}
        maxWidth = "100%"
        closeIt = {() => {setShowForms(false)}}
        title = "Add Form"
        actionKey = "Add"
        handleFormSubmit = {async e => {
            e.preventDefault();
            if(form !== "Multi Site JSA" && !laborCategory.includes("Shop") && jsaSubmitTime === defaultEmptyDateTime){
                window.alert("Complete JSA first");
                return;
            }
            const formData = new MyFormData();
            formData.append("form", form);
            formData.append("workLogHashKey", workLogHashKey);
            //---------------------------------------------------------
            setShowLoader(true);
            const res = await myAxios("workLogs/addForm.php", formData);
            setShowLoader(false);
            if(!res) return;
            setShowForms(false);
            //---------------------------------------------------------
            if(adminLink){
                setWorkInstructions(workInstructions => workInstructions.map(workInstruction => ({
                    ...workInstruction, multiJSA:(
                        workInstruction.workInstructionHashKey === workInstructionHashKey && form === "Multi Site JSA"?
                        JSON.stringify(res.data):
                        workInstruction.multiJSA
                    )
                })));
                setWorkLogs(workLogs => workLogs.map(workLog => ({
                    ...workLog, potholingForm:(
                        workLog.workLogHashKey === workLogHashKey && form === "potholing"?
                        JSON.stringify(res.data):
                        workLog.potholingForm
                    ), forms:(
                        workLog.workLogHashKey === workLogHashKey && !["potholing", "Multi Site JSA"].includes(form)?
                        JSON.stringify(res.data):
                        workLog.forms
                    )
                })));
            }else{
                setWorkLogs(workLogs => workLogs.map(workLog => ({
                    ...workLog, potholingForm:(
                        workLog.workLogHashKey === workLogHashKey && form === "potholing"?
                        JSON.stringify(res.data):
                        workLog.potholingForm
                    ), multiJSA:(
                        workLog.workLogHashKey === workLogHashKey && form === "Multi Site JSA"?
                        JSON.stringify(res.data):
                        workLog.multiJSA
                    ), forms:(
                        workLog.workLogHashKey === workLogHashKey && !["potholing", "Multi Site JSA"].includes(form)?
                        JSON.stringify(res.data):
                        workLog.forms
                    )
                })));
            }
        }}
    >
        <div className = "m-3">
            <select
                required
                className = "form-control"
                value = {form}
                onChange = {e => setForm(e.currentTarget.value)}
            >
                <option value = "">Select</option>
                <option>Gas Leak Survey</option>
                <option>Incident Report</option>
                <option>Equipment Damage Report</option>
                <option value = "potholing">Potholing Form</option>
                <option>Manhole Form</option>
                <option>Electric Pothole Form</option>
                <option>GPR Form</option>
                <option>Locating Form</option>
                <option>CCTV Form</option>
                <option>Good Catch Form</option>
                <option>Near Miss Form</option>
                <option>Sacramento Vacuum Field Survey</option>
                <option>Weekly Maintenance Zerk Fittings</option>
                <option>Multi Site JSA</option>
                <option>Workplace Violence Incident Report Form</option>
                <option>In Scope Work Diary</option>
                {testerEmails.includes(user.email)?<option>Test Manhole Form</option>:<></>}
                {testerEmails.includes(user.email)?<option>Test Potholing Form</option>:<></>}
            </select>
        </div>
    </Modal>
    )
}